import React, { useState } from "react";
import { Button, ButtonGroup, Dropdown, Modal } from "react-bootstrap";
import Input from "../Builder/nodes/Logic/Inputs/Input";

export default function ControlOverviewModal() {
  const [show, setShow] = useState(false);
  const [creditAllowance, setCreditAllowance] = useState(150);
  const [duration, setDuration] = useState(30);
  const [maxUsers, setMaxUsers] = useState(20);
  const [messageDestinations, setMessageDestinations] = useState(50);
  const [inboundNumbers, setInboundNumbers] = useState(10);
  const [apiConnections, setApiConnections] = useState(10);
  const [additionalInboundNumbers, setAdditionalInboundNumbers] = useState(5);
  const [productType, setProductType] = useState();
  const productsTypes = [
    { value: "boomLogic", label: "boomLogic", info: "lorem" },
    { value: "Logic Workflows", label: "Logic Workflows", info: "lorem" },
    {
      value: "Broadcast & Campaign",
      label: "Broadcast & Campaign",
      info: "lorem",
    },
    { value: "boomAPI", label: "boomAPI", info: "lorem" },
    { value: "boomMail", label: "boomMail", info: "lorem" },
    {
      value: "Solutions (Range of Specific Solutions)",
      label: "Solutions (Range of Specific Solutions)",
      info: "lorem",
    },
    {
      value: "MS Messaging Connector (boomApp Connect)",
      label: "MS Messaging Connector (boomApp Connect)",
      info: "lorem",
    },
    {
      value: "Dynamics 365 Plug-In (boomApp Dynamics)",
      label: "Dynamics 365 Plug-In (boomApp Dynamics)",
      info: "lorem",
    },
    {
      value: "MS Solution Connectorser",
      label: "MS Solution Connectors",
      info: "lorem",
    },
  ];

  return (
    <>
      <button
        className="btn btn-sm bg-colored fw-bold text-white rounded-3"
        onClick={() => setShow(true)}
      >
        Edit
      </button>

      <Modal show={show} centered onHide={() => setShow(false)} size="xl">
        <Modal.Header
          className="bg-colored-reverse p-3 rounded-3 rounded-bottom-0"
          closeButton
        >
          <Modal.Title>Controls Overview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 my-3 ">
            <div className="row mb-4">
              <div className="mb-3 col-3 ">
                <div>
                  <span className="fw-bold me-1">Customer Name:</span>
                  <span>John Doe</span>
                </div>
                <div>
                  <span className="fw-bold me-1">Trial Type:</span>
                  <span>Trial</span>
                </div>
              </div>
              <div className="mb-3 col-3">
                <div>
                  <span className="fw-bold me-1">Company Name:</span>
                  <span>Example Company</span>
                </div>
                <div>
                  <span className="fw-bold me-1">Permissions:</span>
                  <span>View, Edit</span>
                </div>
              </div>
              <div className="mb-3 col-3">
                <div>
                  <span className="fw-bold me-1">Reference num:</span>
                  <span>1235</span>
                </div>
                <div>
                  <span className="fw-bold me-1">Industry:</span>
                  <span>Communication</span>
                </div>
              </div>
              <div className="mb-3 col-auto">
                <span className="fw-bold me-1">Products:</span>
                <span className="">
                  <Dropdown as={ButtonGroup} style={{ minWidth: 180 }}>
                    <Dropdown.Toggle
                      className="bg-purple-gradient text-black d-flex align-items-center justify-content-between"
                      id="dropdown-split-basic"
                    >
                      {productType ? (
                        <div className="text-start">
                          <div className="fw-bold">{productType.label}</div>
                          <div className="">{productType.info}</div>
                        </div>
                      ) : (
                        "Select Product Type"
                      )}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {productsTypes.map((type) => (
                        <Dropdown.Item
                          as={Button}
                          key={type.value}
                          onClick={() => setProductType(type)}
                        >
                          <div className="fw-bold">{type.label}</div>
                          <div className="text-secondary">{type.info}</div>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </span>
              </div>
            </div>
            <div className="fw-bold">Controls Overview </div>
            <div className="my-2 row align-items-center justify-content-between ">
              <div className="col-4">Message credit allowance: </div>
              <div className="fw-bold ms-1 col-4">
                <Input
                  isSelect
                  value={[creditAllowance]}
                  onChange={(v) => setCreditAllowance(v[0])}
                  options={[
                    { label: "150", value: 150 },
                    { label: "200", value: 200 },
                    { label: "250", value: 250 },
                  ]}
                />
              </div>
            </div>
            <div className="my-2 row align-items-center justify-content-between ">
              <div className="col-4">Duration: </div>
              <div className="fw-bold ms-1 col-4">
                <Input
                  isSelect
                  value={[duration]}
                  onChange={(v) => setDuration(v[0])}
                  options={[
                    { label: "10", value: 10 },
                    { label: "20", value: 20 },
                    { label: "30", value: 30 },
                    { label: "40", value: 40 },
                    { label: "50", value: 50 },
                    { label: "60", value: 60 },
                    { label: "70", value: 70 },
                    { label: "80", value: 80 },
                    { label: "90", value: 90 },
                    { label: "100", value: 100 },
                  ]}
                />
              </div>
            </div>
            <div className="my-2 row align-items-center justify-content-between ">
              <div className="col-4">Max users: </div>
              <div className="fw-bold ms-1 col-4">
                <Input
                  isSelect
                  value={[maxUsers]}
                  onChange={(v) => setMaxUsers(v[0])}
                  options={[
                    { label: "1", value: 1 },
                    { label: "2", value: 2 },
                    { label: "3", value: 3 },
                    { label: "4", value: 4 },
                    { label: "5", value: 5 },
                    { label: "10", value: 10 },
                    { label: "15", value: 15 },
                    { label: "20", value: 20 },
                  ]}
                />
              </div>
            </div>
            <div className="my-2 row align-items-center justify-content-between ">
              <div className="col-4">
                Access to messaging destinations (Local / international
                messaging):
              </div>
              <div className="fw-bold ms-1 col-4">
                <Input
                  isSelect
                  value={[messageDestinations]}
                  onChange={(v) => setMessageDestinations(v[0])}
                  options={[
                    { label: "50", value: 50 },
                    { label: "100", value: 100 },
                    { label: "150", value: 150 },
                  ]}
                />
              </div>
            </div>
            <div className="my-2 row align-items-center justify-content-between ">
              <div className="col-4">
                Inbound numbers quantity per country :
              </div>
              <div className="fw-bold ms-1 col-4">
                <Input
                  isSelect
                  value={[inboundNumbers]}
                  onChange={(v) => setInboundNumbers(v[0])}
                  options={[
                    { label: "5", value: 5 },
                    { label: "10", value: 10 },
                    { label: "15", value: 15 },
                  ]}
                />
              </div>
            </div>
            <div className="my-2 row align-items-center justify-content-between ">
              <div className="col-4"> Number of API connections:</div>
              <div className="fw-bold ms-1 col-4">
                <Input
                  isSelect
                  value={[apiConnections]}
                  onChange={(v) => setApiConnections(v[0])}
                  options={[
                    { label: "5", value: 5 },
                    { label: "10", value: 10 },
                    { label: "15", value: 15 },
                  ]}
                />
              </div>
            </div>
            <div className="my-2 row align-items-center justify-content-between ">
              <div className="col-4">
                {" "}
                Inbound numbers quantity per country :
              </div>
              <div className="fw-bold ms-1 col-4">
                <Input
                  isSelect
                  value={[additionalInboundNumbers]}
                  onChange={(v) => setAdditionalInboundNumbers(v[0])}
                  options={[
                    { label: "5", value: 5 },
                    { label: "10", value: 10 },
                    { label: "15", value: 15 },
                  ]}
                />
              </div>
            </div>
            <div className="my-2 text-secondary">
              Additional controls will be defined for the different trial types
              as required.
            </div>
            <div className="d-flex justify-content-end">
              <Button
                className="mt-3 bg-colored fw-bold"
                onClick={() => setShow(false)}
              >
                Save
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
